module.exports = [
  '54b58957112602c9a0be7aa3' # inspiringboards
  '54f4ca2e40406f2c50b072a0' # quadrosinspiradores
]



// WEBPACK FOOTER //
// ./app/scripts/data/copy-board-header-button-teams.coffee